<template>
	<div class="nav nav-pills">
		<div class="btn-group overflow-auto" role="group" aria-label="Basic example">
			<button
				v-for="tab in tabs"
				class="btn btn-secondary nowrap" 
				:id="'nav-option-'+tab.field" 
				@click="nav_change(tab.field)">
				{{ tab.label }}
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
	        tabs: {
	            type: Array
	        },
	    },

		mounted(){
			// set o primeiro enviado como ativo
			if($('#nav-option-'+this.tabs[0]['field']).hasClass('btn-secondary')){
				document.getElementById('nav-option-'+this.tabs[0]['field']).classList.remove("btn-secondary");
			}
			var el = document.getElementById('nav-option-'+this.tabs[0]['field']);
			el.classList.add("btn-primary");
		},

		methods: {
			nav_change(tab){
				for (var i=0; i<this.tabs.length; i++) {
					if($('#nav-option-'+this.tabs[i]['field']).hasClass('btn-primary')){
						var el = document.getElementById('nav-option-'+this.tabs[i]['field']);
						el.classList.remove("btn-primary");
						el.classList.add("btn-secondary");
					}
				}

				if($('#nav-option-'+tab).hasClass('btn-secondary')){
					document.getElementById('nav-option-'+tab).classList.remove("btn-secondary");
				}

				var el = document.getElementById('nav-option-'+tab)
				el.classList.add("btn-primary");

				this.$emit('navChanged', tab);
			},
		}
	}
</script>

<style scoped>
	#bsh-tab button {
		background-color: white;
	}
	.cl-blue {
		color: blue;
	}
	.nowrap {
		white-space:nowrap;
	}
</style>